// extracted by mini-css-extract-plugin
export default {"content":"styles_content__yzplf","image":"styles_image__0mdlx","button-wrapper":"styles_button-wrapper__uXcfz"};